import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-full-page-main-layout',
  templateUrl: './full-page-main-layout.component.html',
  styleUrls: ['./full-page-main-layout.component.scss']
})
export class FullPageMainLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
